/**
 * Salir de la SPA: al SSO, o al logout del SSO. Una navegación de verdad, no
 * del router.
 *
 * Aparte para que las pruebas puedan sustituirla: `window.location` no se deja
 * cambiar en jsdom.
 */
export const navigateAway = (url: string): void => {
  window.location.assign(url);
};
